export const _authFr = {
    bip: 'Bip',
    radio: 'Radio',
    planning: 'Planning',
    operations: 'Gestion des opérations',
    alerts: 'Gestion des alertes',
    config: 'Configuration',
    superAdmin: 'Administrateur',
    geographicSystem: 'Système informations géographique',
    admin: {
        assignments: 'Affectations',
        players: 'Joueurs',
        buildings: 'Bâtiments',
        vehicleModels: 'Modèles de véhicules',
        functions: 'Fonctions de véhicule',
        skills: 'Compétences de personnels',
        ranks: 'Grades',
        status: 'Statuts',
        services: 'Services',
        shop: 'Boutique',
        incidents: 'Incidents',
    },
    new: 'Ajouter',
    manage: 'Gérer',
    delete: 'Supprimer',
};

export const _authEn = {
    bip: 'Beep',
    radio: 'Radio',
    planning: 'Planning',
    operations: 'Operations management',
    alerts: 'Alert management',
    config: 'Configuration',
    superAdmin: 'Administrator',
    geographicSystem: 'Geographic Information System',
    admin: {
        players: 'Players',
        buildings: 'Buildings',
        vehicleModels: 'Vehicle Models',
        functions: 'Vehicle functions',
        skills: 'Staff skills',
        ranks: 'Ranks',
        status: 'Status',
        services: 'Services',
        shop: 'Shop',
        incidents: 'Incidents',
    },
    new: 'Add',
    manage: 'Manage',
    delete: 'Delete',
};

export const _authDe = {
    bip: 'Piepen',
    radio: 'Radio',
    planning: 'Planung',
    operations: 'Betriebsführung',
    alerts: 'Alarmverwaltung',
    config: 'Konfiguration',
    superAdmin: 'Administrator',
    geographicSystem: 'Geographisches Informationssystem',
    admin: {
        players: 'Spieler',
        buildings: 'Gebäude',
        vehicleModels: 'Fahrzeugmodelle',
        functions: 'Fahrzeugfunktionen',
        skills: 'Personalqualifikationen',
        ranks: 'Ränge',
        status: 'Status',
        services: 'Dienstleistungen',
        shop: 'Geschäft',
        incidents: 'Vorfälle',
    },
    new: 'Hinzufügen',
    manage: 'Verwalten',
    delete: 'Löschen',
};
